import React, { useMemo } from 'react';

import { Dialog } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import type { CredentialedScanningRow } from '../types';
import { CredentialedScanningType } from '../types';

import { ScanCredentialForm } from './scan-credential-form/scan-credential-form';

type ScanCredentialsDialogProps = {
  scannerId: string;
  onClose: () => void;
  credentialedScanningRowData?: CredentialedScanningRow | undefined;
};

export const ScanCredentialsDialog: React.FC<ScanCredentialsDialogProps> = ({
  scannerId,
  onClose,
  credentialedScanningRowData,
}) => {
  const { t } = useTranslation('telemetryScannerConfig');

  const scanCredentialFormData = useMemo(() => {
    if (!credentialedScanningRowData) {
      return undefined;
    }

    const { description, name, targets, type } = credentialedScanningRowData;

    return {
      description,
      name,
      targets,
      type:
        type === CredentialedScanningType.Up
          ? CredentialedScanningType.Up
          : CredentialedScanningType.Usk,
      username: '',
    };
  }, [credentialedScanningRowData]);

  return (
    <Dialog.Root isOpen>
      <Dialog.Content borderRadius="small" onPointerDownOutside={onClose}>
        <Dialog.Header style={{ paddingBottom: '0px' }}>
          <Dialog.HeaderTitle>
            {t(
              `credentialedScanningForm.title${
                scanCredentialFormData ? 'Edit' : 'New'
              }`,
            )}
          </Dialog.HeaderTitle>
          <Dialog.HeaderDescription>
            {t('credentialedScanningForm.subtitle')}
          </Dialog.HeaderDescription>
        </Dialog.Header>
        <Dialog.Body>
          <ScanCredentialForm
            scannerId={scannerId}
            onClose={onClose}
            {...(scanCredentialFormData && {
              scanCredentialFormData,
              credentialId: credentialedScanningRowData?.id,
            })}
          />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Root>
  );
};
